import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import {environment} from '../../../../environments/environment';

@Component({
  selector: 'app-respond-ticket',
  templateUrl: './respond-ticket.component.html',
  styleUrls: ['./respond-ticket.component.scss']
})
export class RespondTicketComponent implements OnInit {

  public msg: string;
  public isLiked: boolean;
  public isLikedAlready: boolean;

  public currentPos: number = 0;

  projectName = environment.projectName;

  constructor(
    public activeModal: NgbActiveModal
  ) {
  }

  ngOnInit() {
  }

  sent() {
    this.activeModal.close({ msg: this.msg, like: this.isLiked, isLikedAlready: this.isLikedAlready })
  }

  cancel() {
    this.activeModal.close({ canceled: true })
  }

  onChangeTextArea(event) {
    this.currentPos = event.target.value.length;
  }
}
